import React from 'react';
import {connect} from 'react-redux';
import {BaseComponent as Component} from 'BaseComponent';
import Const from 'constants';
import $ from 'jquery';
import Action from 'actions';
import StackBaseValidator from 'components/organisms/nhl-non-controlled-stacking/validators/stack-base-validator';
import StackLineGroupValidator from 'components/organisms/nhl-non-controlled-stacking/validators/stack-line-group-validator';
import NumberHelper from 'helpers/number-helper';
import {showPopup} from 'helpers/modal';
import {getTeamNamesOfGames} from 'helpers/game-helper';
import {generateRandomKey} from 'helpers/hash';

class Settings extends Component {
    constructor(props) {
        super(props);
        const group = {
            playersQuantity: Const.NHL_NON_CONTROLLED_STACK_MIN_PLAYERS_QUANTITY,
            team: '',
            lineGroups: [],
            ppLines: [],
        };
        this.defaultState = {
            stackMode: 1,
            exposure: '',
            groups: {
                1: {...group},
                2: {...group},
                3: {...group},
            },
        };
        this.state = {...this.defaultState};
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        const {stack} = this.props;
        if (stack.isReset && !prevProps.stack.isReset) {
            this.setState({...this.defaultState});
        }
    }

    setStackMode(value) {
        this.setState({
            stackMode: value,
        });
    }

    onChangeExposure(value) {
        this.setState({
            exposure: value,
        });
    }

    onBlurExposure(value) {
        let expValue = NumberHelper.prepareInt(value).limitByRange(1, 100, '').get();

        this.setState({
            exposure: expValue,
        });
    }

    setPlayersInGroup(groupNumber, value) {
        let groups = {...this.state.groups};
        groups[groupNumber].playersQuantity = Number(value);
        this.setState({
            groups: {...groups},
        });
    }

    selectTeam(groupNumber, value) {
        let groups = {...this.state.groups};
        groups[groupNumber].team = value;
        this.setState({
            groups: {...groups},
        });
    }

    setLineGroup(groupNumber, value) {
        let groups = {...this.state.groups};
        let lineGroups = [...groups[groupNumber].lineGroups];
        if (!inArray(value, lineGroups)) {
            lineGroups.push(value);
        } else {
            lineGroups.splice($.inArray(value, lineGroups), 1);
        }
        groups[groupNumber].lineGroups = [...lineGroups];
        this.setState({
            groups: {...groups},
        });
    }

    setPPLine(groupNumber, value) {
        let groups = {...this.state.groups};
        let ppLines = [...groups[groupNumber].ppLines];
        if (!inArray(value, ppLines)) {
            ppLines.push(value);
        } else {
            ppLines.splice($.inArray(value, ppLines), 1);
        }
        groups[groupNumber].ppLines = [...ppLines];
        this.setState({
            groups: {...groups},
        });
    }

    addRule() {
        try {
            let stack = {...this.state};

            let groups = {};
            Object.keys(stack.groups).map((groupNumber) => {
                if (groupNumber <= stack.stackMode) {
                    groups[groupNumber] = {...stack.groups[groupNumber]};
                }
            });
            stack.groups = groups;

            const stackLineGroupValidator = new StackLineGroupValidator();
            stackLineGroupValidator.setDependencies({stacking: stack});

            const validator = new StackBaseValidator();
            validator.setDependencies({stacking: stack});
            validator.addSubValidators([stackLineGroupValidator]);

            if (validator.validate()) {
                let key = generateRandomKey();
                this.props.dispatch(Action.set('NonControlledStack', {[key]: {...stack}}));
            } else {
                throw new Error(validator.getFirstError());
            }
        } catch (e) {
            this.props.dispatch(showPopup(e.message));
        }
    }

    getListOfTeams() {
        const {games} = this.props;

        let teamNames = [];
        if (this.isStateReady(games, 'data')) {
            teamNames = getTeamNamesOfGames(games.getAllAsArr());
        }

        return teamNames;
    }

    getTeamBlock(groupNumber) {
        const {sportConfig} = this.props;
        let rangeNonControlledPositions = sportConfig.getConfigProp('rangeNonControlledPositions', []);

        let rangePositions = [];
        rangeNonControlledPositions.map((item) => {
            rangePositions.push(
                <option key={item} value={item}>
                    {item}
                </option>,
            );
        });

        let teams = this.getListOfTeams();

        return (
            <div key={groupNumber} className="team-stack">
                <h3>STACK {groupNumber}</h3>
                <div className="form-row flex-start mb5">
                    <div className="form-sub-text">
                        <strong>Stack</strong>
                        <select
                            value={this.state.groups[groupNumber].playersQuantity}
                            onChange={(e) => ::this.setPlayersInGroup(groupNumber, e.target.value)}
                            className="form-control input-sm"
                        >
                            {rangePositions}
                        </select>
                        <strong>players</strong>
                    </div>
                    <div className="form-sub-text">
                        <strong>from</strong>
                        <select
                            onChange={(e) => ::this.selectTeam(groupNumber, e.target.value)}
                            value={this.state.groups[groupNumber].team}
                            className="form-control input-md"
                        >
                            <option value="">Team</option>
                            {teams.map((team) => {
                                return (
                                    <option key={team} value={team}>
                                        {team}
                                    </option>
                                );
                            })}
                        </select>
                    </div>
                </div>
                <div className="form-row flex-start">
                    <div className="line-groups">
                        {Const.NHL_NON_CONTROLLED_STACK_LINE_GROUPS.map((lineGroup) => {
                            return (
                                <label className="checkbox-inline" key={lineGroup}>
                                    <input
                                        type="checkbox"
                                        checked={inArray(lineGroup, this.state.groups[groupNumber].lineGroups)}
                                        onChange={() => ::this.setLineGroup(groupNumber, lineGroup)}
                                    />
                                    {`L${lineGroup}`}
                                </label>
                            );
                        })}
                    </div>
                    <div className="pp-lines">
                        {Const.NHL_NON_CONTROLLED_STACK_PP_LINES.map((ppLine) => {
                            return (
                                <label className="checkbox-inline" key={ppLine}>
                                    <input
                                        type="checkbox"
                                        checked={inArray(ppLine, this.state.groups[groupNumber].ppLines)}
                                        onChange={() => ::this.setPPLine(groupNumber, ppLine)}
                                    />
                                    {`PP${ppLine}`}
                                </label>
                            );
                        })}
                    </div>
                </div>
            </div>
        );
    }

    render() {
        let teamsQuantity = [],
            teamsBlocks = [];
        for (let i = 1; i <= Const.NHL_NON_CONTROLLED_STACK_MAX_GROUPS; i++) {
            teamsQuantity.push(
                <label className="radio-inline" key={i}>
                    <input
                        type="radio"
                        name="teams-quantity"
                        checked={i == this.state.stackMode}
                        onChange={() => ::this.setStackMode(i)}
                    />
                    {i}
                </label>,
            );
            if (i <= this.state.stackMode) {
                teamsBlocks.push(this.getTeamBlock(i));
            }
        }

        return (
            <div className="white-box">
                <h2 className="mb15">Lines Stacking Rules</h2>
                <div className="mb20">
                    <span className="radio-inline">Number of teams:</span>
                    {teamsQuantity}
                    <span className="radio-inline">Exposure:</span>
                    <div className="percent-in exposure-percent-in">
                        <input
                            type="text"
                            className="form-control input-sm"
                            value={`${this.state.exposure}`}
                            onChange={(e) => ::this.onChangeExposure(e.target.value)}
                            onBlur={(e) => ::this.onBlurExposure(e.target.value)}
                        />
                        <span className="percent">%</span>
                    </div>
                </div>
                <div className="stack-filter">{teamsBlocks}</div>
                <div className="text-right">
                    <button type="submit" onClick={::this.addRule} className="btn">
                        Add rule
                    </button>
                </div>
            </div>
        );
    }
}

function mapStatesToProps(state) {
    const {playersData, sportConfig, stacks} = state;
    return {
        sportConfig,
        games: playersData.games,
        stack: stacks.nonControlled,
    };
}

export default connect(mapStatesToProps)(Settings);
